// extracted by mini-css-extract-plugin
module.exports = {"description":"Press_description__PW5Bs","contacts":"Press_contacts__H8f2k"};